import PoolDescription, { I18N_CONTEXT } from './crowdfunding_story'
import { getI18n } from 'client/i18n'
import { reduxForm } from 'redux-form'
import _get from 'lodash/get'
import { CROWDFUNDING_DESCRIPTION_LENGTH } from 'shared/lengths'
import { CHARITY_CATEGORY_TO_KEY } from 'shared/category_map'
import { required, length, combine } from 'lib/validators'
import formUtils from 'lib/form_utils'
import { push } from 'react-router-redux'

import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'
import {
  getTranslatedCategoryList,
  isValidCategory,
  filterDepreciatedCategory,
  sortCategory,
} from 'lib/category'

const i18n = getI18n(I18N_CONTEXT)

let validators = [
  required('description', i18n('description_required')),
  length(
    'description',
    CROWDFUNDING_DESCRIPTION_LENGTH,
    i18n('description_too_long', {
      maxLength: CROWDFUNDING_DESCRIPTION_LENGTH,
    })
  ),
]

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  let categoryList = getTranslatedCategoryList(state)
  const isNewCategoryEnabled = state.flags.enable_new_category
  categoryList = filterDepreciatedCategory(categoryList, isNewCategoryEnabled)
  const countryCode = state.country.country_code
  if (countryCode === 'DE') {
    categoryList = categoryList.filter(category => category.key !== '1017')
  }

  categoryList = sortCategory(categoryList)
  const categoryQueryParam = _get(state, 'queryParams.category')
  // category initial/default value
  let category =
    campaign.category ||
    (isValidCategory(state, categoryQueryParam)
      ? categoryQueryParam
      : categoryList[0] && categoryList[0].value)

  if (campaign.npid) {
    category =
      CHARITY_CATEGORY_TO_KEY[_get(campaign, 'charity.cause_area[0].name', '')]
  }

  return {
    shouldAutoFocus: props.router.params.action !== 'POP',
    initialValues: {
      category,
      description: campaign.description,
    },
    charity: campaign.charity,
    categoryList,
    npid: campaign.npid,
  }
}

const mapDispatchToProps = dispatch => {
  // event_name is hardcoded for crowdfunding phase 1
  return {
    onSubmit(formValues) {
      dispatch(
        setData(NEW_CAMPAIGN_ID, {
          description: formValues.description,
          category: formValues.category,
          event_name: 'COVID-19',
        })
      )
      dispatch(
        push({
          pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create-crowdfunding/cover`,
        })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'crowdfunding_story',
    destroyOnUnmount: false,
    fields: ['category', 'description'],
    touchOnBlur: true,
    touchOnChange: false,
    validate: combine(...validators),
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(PoolDescription))
